import { OAuthProvider } from '@seapoint/server/enums';
import googleLogo from '../../../assets/images/google-logo.svg';
import xeroLogo from '../../../assets/images/logo-xero.svg';
import { cn } from '../../../utils/cn';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { AllowedOAuthProvider } from './oauth-connection-badge';

type OAuthProviderLogoIconProps = {
  provider: AllowedOAuthProvider;
  className?: string;
};

export const OAuthProviderLogoIcon = ({ provider, className }: OAuthProviderLogoIconProps) => {
  const { logo, testId } = getOAuthProviderLogoIconContent(provider);

  return (
    <div data-testid={testId} className={cn('h-4 w-4', className)}>
      <img src={logo} alt="" loading="eager" fetchPriority="high" className="h-full w-full object-cover" />
    </div>
  );
};

const getOAuthProviderLogoIconContent = (provider: AllowedOAuthProvider) => {
  switch (provider) {
    case OAuthProvider.GMAIL:
      return {
        logo: googleLogo,
        testId: 'google-logo-icon',
      };
    case OAuthProvider.XERO:
      return {
        logo: xeroLogo,
        testId: 'xero-logo-icon',
      };
    default:
      return exhaustiveCheck(provider);
  }
};
